import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;
// =================Emp Education URL=====================
export const Get_Blog_List = `${BASE_API_URL}/Blog/GetBlog_List`;
export const Get_Event_List = `${BASE_API_URL}/Event/GetEvent_List`;
export const Get_Album_List = `${BASE_API_URL}/Album/GetAlbumList`;
export const Get_Gallery_Image_List = `${BASE_API_URL}/AlbumMedia/GetAlbumMediaList`;
export const Get_Banner_List = `${BASE_API_URL}/Banner/Banner_GetList`;
export const Get_AlbumMedia_GetListActive_IsHome = `${BASE_API_URL}/AlbumMedia/AlbumMedia_GetListActive_IsHome`;
export const Get_AlbumMedia_GetBy_AlbumID = `${BASE_API_URL}/AlbumMedia/AlbumMedia_GetBy_AlbumID`;
export const GET_ALL_SERVICE = `${BASE_API_URL}/Service/Service_GetList`; //Get Country Page
export const Get_Item_Category_Active_List = `${BASE_API_URL}/ItemCategory/ItemCategory_ActiveList_Dropdown`;
export const Get_Product_Active_List_ByCategoryID = `${BASE_API_URL}/Item/GetProductActiveList_ByCategoryID`;
export const Get_Product_ByProductID = `${BASE_API_URL}/Item/Item_GetBy_ItemID`;
export const Get_ProdDtls_ByProductID_WithMultiplePhotoPath = `${BASE_API_URL}/Item/ProductDetails_GetBy_ItemID_WithMultiplePhotoPath`;

export const Apply_Product_Inquiry_Details = `${BASE_API_URL}/OurService/ProductInquiry_AddDetails`;
export const Get_Our_Service_List = `${BASE_API_URL}/OurService/GetOurService_List`;
export const Get_Our_Service_By_ServiceID = `${BASE_API_URL}/OurService/OurService_GetBy_ServiceID`;

export function getOurServiceByServiceID(ourServiceID) {
  return axios.post(Get_Our_Service_By_ServiceID, {
    ourServiceID,
  });
}
export function getOurServiceList() {
  return axios.get(Get_Our_Service_List);
}
// --------------------------------------------
export function applyProduct_InquiryDetails(
  personName,
  personEmailID,
  personContactNumber,
  personMessage,
  ipAddress,
  isSeen,
  businessID,
  ourServiceID,
  inquiryTypeID,
  productID,
  productCategoryID
) {
  return axios.post(Apply_Product_Inquiry_Details, {
    personName,
    personEmailID,
    personContactNumber,
    personMessage,
    ipAddress,
    isSeen,
    businessID,
    ourServiceID,
    inquiryTypeID,
    productID,
    productCategoryID,
  });
}

// ------------------------------------------
export function getProductByProductID(productID) {
  return axios.post(Get_Product_ByProductID, {
    productID,
  });
}
export function getProdDtlsByProductID_WithMultiplePhoto(productID) {
  return axios.post(Get_ProdDtls_ByProductID_WithMultiplePhotoPath, {
    productID,
  });
}
export function getProductActiveListByCategoryID(productCategoryID) {
  return axios.post(Get_Product_Active_List_ByCategoryID, {
    productCategoryID,
  });
}
export function getItemCategoryActiveList() {
  return axios.get(Get_Item_Category_Active_List);
}

export function getAllServiceList() {
  return axios.get(GET_ALL_SERVICE);
}

export function getBlogList() {
  return axios.get(Get_Blog_List);
}
export function getEventList() {
  return axios.get(Get_Event_List);
}
export function getAlbumsList() {
  return axios.get(Get_Album_List);
}
export function getGalleryImageList() {
  return axios.get(Get_Gallery_Image_List);
}
export function getAllBannerList() {
  return axios.get(Get_Banner_List);
}
export function getAlbumMediaGetListActiveIsHome() {
  return axios.get(Get_AlbumMedia_GetListActive_IsHome);
}

// ------------------------------

export function getAlbumMediaByAlbumId(albumID) {
  return axios.post(Get_AlbumMedia_GetBy_AlbumID, { albumID });
}
